module.exports = __webpack_public_path__ + "static/media/science.f2ad5731.png";